import React from 'react';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import PropTypes from 'prop-types';

const getIconType = (resource) => {
  switch (resource.attr('iconType')) {
    case 'error_outline':
      return ErrorIcon;
    case 'warning_outline':
      return WarningIcon;
    case 'completed':
      return CheckCircleIcon;
    case 'incomplete':
      return RadioButtonUncheckedIcon;
    default:
      return null;
  }
};

const getIconFill = (resource) => {
  switch (resource.attr('status')) {
    case 'SUCCESS':
      return 'success';
    case 'WARN':
      return 'orange';
    case 'ERROR':
      return 'red';
    case 'INFO':
      return 'primary';
    case 'COMPLETE':
      return 'primary';
    case 'INCOMPLETE':
      return 'primaryGray';
    default:
      return 'primary';
  }
};

const IconContent = ({
  relationshipCollection,
}) => {
  const [resource] = relationshipCollection;
  const icon = getIconType(resource);

  if (icon === null) {
    return null;
  }

  const fill = getIconFill(resource);

  return (
    <Tooltip
      title={resource.attr('description')}
      placement={'bottom'}
    >
      <Icon
        icon={icon}
        fill={fill}
      />
    </Tooltip>
  );
};

IconContent.propTypes = {
  relationshipCollection: PropTypes.object.isRequired,
};

export default IconContent;
